import type { User } from '@/context/auth-context'

const STORAGE_KEY = 'app_auth_v1'

export interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  expiresAt: number | null
}

export function getAuthFromStorage(): AuthState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as AuthState
  } catch {
    return null
  }
}

export function setAuthToStorage(v: AuthState) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(v))
}

export function clearAuthStorage() {
  localStorage.removeItem(STORAGE_KEY)
}
